var _defs, _path, _path2, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew203({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.86,3.15H7.52V2.67h3.26v.48H9.43V7.06H8.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.49,7.06,11.05,2.67h.61l.69,2.16c.19.6.35,1.13.47,1.65h0c.12-.51.31-1.07.5-1.64l.74-2.17h.61L13.11,7.06Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "1.32 12.83 1.32 8.33 6.32 8.33 11.32 8.33 11.32 13.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.32,
    y1: 3.33,
    x2: 6.32,
    y2: 8.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew203);
export default __webpack_public_path__ + "static/media/Symbolpack_New_203.605e298fb9e0dadb2a7fc752ac99b1ca.svg";
export { ForwardRef as ReactComponent };